(ns frontend.shared.crypto
  (:require [promesa.core :as p]))

(def encryption-algorithm-name "AES-CBC")

(def encryption-algorithm-js (clj->js {:name   encryption-algorithm-name
                                       :length 128}))
(def encryption-modes-js (clj->js ["encrypt" "decrypt"]))

(defn random-values [context]
  (-> context
      .-crypto
      (.getRandomValues (js/Uint8Array. 16))))

(defn encrypt [{:keys [context encryption-key iv str-value on-success! on-error!]}]
  (let [encoded-data (-> (js/TextEncoder.)
                         (.encode str-value))]
    (-> context
        .-crypto
        .-subtle
        (.encrypt (clj->js {:name "AES-CBC"
                            :iv   iv})
                  encryption-key
                  encoded-data)
        (p/then (fn [encrypted]
                  (on-success! encrypted)))
        (p/catch (fn [err]
                   (if (fn? on-error!)
                     (on-error! err)
                     (js/console.error "Failed to encrypt data " err)))))))


(defn decrypt [{:keys [context decryption-key iv encrypted-data on-success! on-error!]}]
  (-> context
      .-crypto
      .-subtle
      (.decrypt (clj->js {:name "AES-CBC"
                          :iv   iv})
                decryption-key encrypted-data)
      (p/then (fn [decrypted-data]
                (let [str-result (-> (js/TextDecoder.)
                                     (.decode decrypted-data))]
                  (on-success! str-result))))
      (p/catch (fn [err]
                 (if (fn? on-error!)
                   (on-error! err)
                   (js/console.error "Failed to decrypt : " err))))))
